var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TheHeader", {
        attrs: { toRoot: _vm.toRoot },
        on: { openTreeDialog: _vm.onOpenTreeDialog }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "Index" }, [_vm._v("目次")]),
      _vm._v(" "),
      _c(
        "OverlayScreen",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowTreeDialog,
              expression: "isShowTreeDialog"
            }
          ],
          on: { close: _vm.onCloseTreeDialog }
        },
        [
          _c(
            "BaseDialog",
            {
              attrs: { overflowScroll: true },
              on: { close: _vm.onCloseTreeDialog }
            },
            [
              _c(
                "div",
                { attrs: { slot: "main" }, slot: "main" },
                [
                  _c("Tree", {
                    attrs: {
                      treeData: _vm.treeData,
                      currentPathFromRoot: _vm.currentPathFromRoot
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }